import React, { useEffect, useState } from 'react';
import { RefreshCw, QrCode } from 'lucide-react';
import { fetchOpenHomeSignups } from '../api/analyticsApi';

const OpenHomeSignupPanel = ({ startDate, endDate }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        fetchOpenHomeSignups(startDate, endDate)
            .then((res) => { if (!cancelled) setData(res); })
            .catch((err) => console.error('Open home signups failed:', err))
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [startDate, endDate]);

    if (loading && !data) {
        return (
            <div className="flex items-center gap-2 text-sm text-gray-500 py-6">
                <RefreshCw className="w-4 h-4 animate-spin" /> Loading open home signups…
            </div>
        );
    }

    const byAgent = data?.by_agent || [];
    const byMedium = data?.by_medium || [];

    return (
        <div className="bg-white rounded-xl border border-gray-200 p-5">
            <h3 className="text-sm font-semibold text-gray-900 mb-1 flex items-center gap-2">
                <QrCode className="w-4 h-4 text-teal-600" />
                Open home signups by agent
            </h3>
            <p className="text-xs text-gray-400 mb-4">
                Buyer accounts created after QR check-in or invite email · {data?.total ?? 0} total
                {(data?.unattributed ?? 0) > 0 && ` · ${data.unattributed} without agent`}
            </p>

            {byMedium.length > 0 && (
                <div className="flex flex-wrap gap-2 mb-4">
                    {byMedium.map((m) => (
                        <span key={m.medium} className="text-xs px-2.5 py-1 rounded-full bg-gray-100 text-gray-700">
                            {m.label}: <strong>{m.count}</strong>
                        </span>
                    ))}
                </div>
            )}

            {byAgent.length === 0 ? (
                <p className="text-xs text-gray-400 text-center py-4">No attributed signups in this range yet.</p>
            ) : (
                <div className="space-y-2">
                    {byAgent.map((row) => (
                        <div key={row.agent_id} className="flex items-center justify-between text-sm">
                            <span className="text-gray-700 truncate pr-4">{row.agent_name}</span>
                            <span className="font-semibold text-gray-900">{row.signups}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default OpenHomeSignupPanel;
